import type { ReactNode } from 'react'
import { SceneryContext } from './scenery'
import { RoomSceneryContext, useRoomScenery } from './useRoomScenery'

/**
 * One scenery for the whole app: the room, the Bug Hunt and every portrait agree on the hour and
 * the occasion, and the viewer's choice made on one screen holds on the others.
 */
export function SceneryProvider({ children }: { children: ReactNode }) {
  const state = useRoomScenery()

  return (
    <RoomSceneryContext.Provider value={state}>
      <SceneryContext.Provider value={state.scenery}>{children}</SceneryContext.Provider>
    </RoomSceneryContext.Provider>
  )
}
